export default __webpack_public_path__ + "94c9c501a135b40ac820fec9d89e5e12.png";